const map = {
	"./struct1.webp": 60440,
	"./struct10.webp": 55520,
	"./struct11.webp": 2275,
	"./struct12.webp": 94626,
	"./struct2.webp": 99365,
	"./struct3.webp": 85338,
	"./struct4.webp": 23863,
	"./struct5.webp": 39156,
	"./struct6.webp": 17265,
	"./struct7.webp": 98390,
	"./struct8.webp": 55411,
	"./struct9.webp": 44976
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 37367;